import React, { useEffect, useState } from "react";
import { Typography, Row, Table, Spin, message, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import SidebarLayout from "./SidebarLayout";
import { useHistory, useLocation } from "react-router-dom";
import { routes } from "../../routes/Routes";
import _BankerService from "../../modules/BankerService";
import ButtonComponent from "../../components/Button/Button";
import _commonService from "../../modules/commonService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import "./Sponsor.scss";

const { Title } = Typography;

const FacilityDetails = () => {
  const history = useHistory();
  const location = useLocation();
  const firmId = location?.state?.firmId;
  const companyName = location?.state?.companyName;

  const [loading, setLoading] = useState(false);
  const [facilityRows, setFacilityRows] = useState([]);

  useEffect(() => {
    if (!firmId) {
      history.push(routes.sponsors.path);
      return;
    }
    getSponserFacilityListByFirmId();
  }, []);

  const getSponserFacilityListByFirmId = async () => {
    try {
      setLoading(true);
      const res = await _BankerService.getSponserFacilityListByFirmId(
        firmId,
        localStorage.getItem("BankerId")
      );
      if (res.data.IsSuccess) {
        setFacilityRows(res?.data?.Obj || []);
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onRowViewClick = (row) => {
    history.push({
      pathname: routes.addEditSponsers.path,
      state: { sponserId: row.SponserId },
    });
  };

  const columns = [
    {
      title: "Credit Facility",
      dataIndex: "LoanProgrameTypeName",
      key: "LoanProgrameTypeName",
      render: (value, row) => (value ? (row.CreditFacilityName ? `${value} (${row.CreditFacilityName})` : value) : "N/A"),
    },
    {
      title: "Utilized / Remaining",
      key: "sizeOutstanding",
      render: (_, row) => (
        <span>
          Utilized: ${_commonService.formatNumberWithCommas(row.Utilized) || "N/A"}
          <br />
          Remaining: ${_commonService.formatNumberWithCommas(row.Remaining) || "N/A"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, row) => (
        <ButtonComponent
          text="View Details"
          icon={<RightOutlined />}
          onClick={() => onRowViewClick(row)}
        />
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <div className="sponsor-page-container facility-details-page">
          <Row gutter={[8, 8]} className="dashboard-header">
            <Title level={3} className="page-title">
              Facility Details
            </Title>

            <Button
              icon={<LeftOutlined />}
              className="add-btn"
              onClick={() => history.push(routes.sponsors.path)}
            >
              Back
            </Button>
          </Row>

          <div className="card-section">
            {companyName && (
              <Title level={5} className="form-title">
                {companyName}
              </Title>
            )}
            <Table
              columns={columns}
              dataSource={facilityRows}
              rowKey="SponserId"
              pagination={false}
              className="transparent-table"
              locale={{ emptyText: "No Credit Facilities Found" }}
            />
          </div>
        </div>
      </SidebarLayout>
    </Spin>
  );
};

export default FacilityDetails;
